import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";

import { SimpleTableHeaderCell } from "../../../../components/TableHeaderCell";

const TABLE_NAME = "billingsTable";

interface IHeaderCellProps {
  params: GridColumnHeaderParams;
}

export const BillingsTableHeaderCell: React.FC<IHeaderCellProps> = ({ params }) => {
  return <SimpleTableHeaderCell tableName={TABLE_NAME} params={params} />;
};
